import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import InputPassword from "components/InputPasswordCustome";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import Swal from "sweetalert2";
// import AppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import IconButton from "@mui/material/IconButton";
// import EmailIcon from "@mui/icons-material/Email";
// import PhoneIcon from "@mui/icons-material/Phone";
import { sendEmailOTP } from "api/OTPService";
import SampleLogo from "assets/images/logos/LogoZumi.png";
import { register, validate } from "api/UserAPI";
// import Home from "@mui/icons-material/Home";
import Navbars from "examples/Navbars";
import {
  Alert,
  Box,
  Snackbar,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
// import SampleLogo from "assets/images/logos/LogoZumi.png";
import "./Style.scss";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { generateCaptcha } from "api/api_register2FA";
import ValidateOTP from "./validateOTP";
// import { useColorTheme } from "../../../context/ColorThemeContext";

function SignUp() {
  // const colors = useColorTheme();
  // State management
  useEffect(() => {
    // Lưu lại màu gốc để khôi phục sau nếu cần
    const wrapper = document.querySelector(".wrapper");
    const oldBg = wrapper?.getAttribute("style");

    if (wrapper) {
      wrapper.setAttribute("style", "background-color: white");
    }

    return () => {
      // Khôi phục lại khi rời trang login
      if (wrapper && oldBg !== null) {
        wrapper.setAttribute("style", oldBg);
      }
    };
  }, []);
  const [captchaInput, setCaptchaInput] = useState(""); // State to store the CAPTCHA input by user
  const [captchaUrl, setCaptchaUrl] = useState(""); // State để lưu URL CAPTCHA
  const [captchaError, setCaptchaError] = useState(null); // Lưu thông báo lỗi CAPTCHA
  const [failedAttempts] = useState(0); // New state for failed login attempts
  const [userData, setUserData] = useState({
    fullname: "",
    email: "",
    phoneNumber: "",
    password: "",
  });
  const [password, setPassword] = useState({
    password: "",
    showPassword: false,
  });
  const [rePassword, setRePassword] = useState({
    password: "",
    showPassword: false,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({ ...prevData, [name]: value }));
  };

  const [isLoginFail, setIsLoginFail] = useState(false);
  const [isShowOTP, setIsShowOTP] = useState(false);
  const navigate = useNavigate();
  const [agreeTerms, setAgreeTerms] = useState(false);

  // Fetch CAPTCHA when the component is mounted
  useEffect(() => {
    if (failedAttempts >= 5) {
      // Show CAPTCHA only after 3 failed attempts
      const fetchCaptcha = async () => {
        try {
          const captchaData = await generateCaptcha();
          // eslint-disable-next-line no-console
          console.log(captchaData); // In ra dữ liệu trả về từ API để kiểm tra
          if (captchaData.success) {
            setCaptchaUrl(captchaData.captchaUrl); // Assuming CAPTCHA response has a 'captcha' field
          } else {
            setCaptchaError("Không thể tải CAPTCHA. Vui lòng thử lại.");
          }
        } catch (err) {
          setCaptchaError("Đã xảy ra lỗi khi tải CAPTCHA. Vui lòng thử lại.");
        }
      };
      fetchCaptcha();
    }
  }, [failedAttempts]); // Re-run when failedAttempts changes
  const handleRefreshCaptcha = async () => {
    try {
      const res = await generateCaptcha();

      if (res.success) {
        setCaptchaUrl(res.captchaUrl);
        setCaptchaInput(""); // reset ô nhập nếu cần
        setCaptchaError(false); // reset lỗi nếu có
      }
      if (!res.success) {
        alert("Quá nhiều yêu cầu. Vui lòng thử lại sau ít phút.");
      }
    } catch (error) {
      if (error.response && error.response.status === 429) {
        // Kiểm tra mã lỗi 429 - Too Many Requests
        // Hiển thị thông báo cho người dùng khi vượt quá giới hạn yêu cầu
        alert("Quá nhiều yêu cầu. Vui lòng thử lại sau.");
      } else {
        // Hiển thị thông báo lỗi khác nếu có
        alert("Đã xảy ra lỗi. Vui lòng thử lại.");
      }
    }
  };
  const [responseData, setResponseData] = useState({
    message: "",
  });
  const validateForm = () => {
    const { fullname, email } = userData;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // const phoneRegex = /^(0|\+84)(\d{9})$/;

    if (!fullname.trim()) {
      setResponseData({ message: "Họ và tên không được để trống" });
      return false;
    }
    if (!emailRegex.test(email)) {
      setResponseData({ message: "Email không hợp lệ" });
      return false;
    }
    if (email?.length > 50) {
      setResponseData({ message: "Email không được quá 50 ký tự" });
      return false;
    }
    // if (phoneNumber.trim().length > 0) {
    //   if (phoneRegex.test(phoneNumber)) {
    //     setResponseData({ message: "Số điện thoại không hợp lệ" });
    //     return false;
    //   }
    // }

    if (!password.password || password.password.trim() === "") {
      setResponseData({ message: "Mật khẩu không được để trống" });
      return false;
    }
    if (password?.password?.length > 50) {
      setResponseData({ message: "Mật khẩu không được quá 50 ký tự" });
      return false;
    }
    if (!rePassword.password || rePassword.password.trim() === "") {
      setResponseData({ message: "Xác nhận mật khẩu không được để trống" });
      return false;
    }
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (!strongPasswordRegex.test(password.password)) {
      setResponseData({
        message:
          "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt",
      });
      return false;
    }
    if (password.password !== rePassword.password) {
      setResponseData({ message: "Mật khẩu xác nhận không khớp" });
      return false;
    }

    if (failedAttempts >= 5 && !captchaInput.trim()) {
      setResponseData({ message: "Vui lòng nhập CAPTCHA" });
      return false;
    }

    setResponseData({ message: "" }); // clear message nếu hợp lệ
    return true;
  };
  const [isLoading, setIsLoading] = useState(false);
  const openViewOTP = async () => {
    if (!validateForm()) return;

    const finalData = {
      ...userData,
      password: password.password,
      rePassword: rePassword.password,
    };

    setIsLoading(true); // 👉 Bắt đầu loading sớm để tránh delay

    try {
      const data = await validate(finalData); // ⬅️ await để đồng bộ
      if (!data) {
        setResponseData({
          message: "Có lỗi xảy ra trong hệ thống",
          status: 201,
        });
        setIsLoading(false);
        return;
      }

      setResponseData(data);

      if (data.status !== 200) {
        Swal.fire({
          title: data.message,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
        setIsLoading(false);
        return;
      }

      const check = await sendEmailOTP(userData.email);
      if (check) {
        setIsShowOTP(true);
      }
    } catch (error) {
      console.error("Lỗi gửi OTP:", error);
      Swal.fire({
        title: "Đã xảy ra lỗi khi gửi OTP",
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
    } finally {
      setIsLoading(false); // 🔁 Đảm bảo loading luôn được tắt
    }
  };

  const handleSignUp = async () => {
    if (!validate()) return;
    const finalData = {
      ...userData,
      password: password.password,
      rePassword: rePassword.password,
    };
    register(finalData).then((data) => {
      if (data) {
        setResponseData(data);
        if (data.status === 200) {
          setUserData({
            fullname: "",
            email: "",
            phoneNumber: "",
            password: "",
          });
          setIsShowOTP(false);
          Swal.fire({
            title: data.message,
            icon: "success",
            showConfirmButton: false,
            timer: 2000, // hoặc 3000 nếu muốn
          }).then(() => {
            // Đợi thêm 1s nữa sau khi Swal đóng, nếu muốn tổng cộng 3s
            setTimeout(() => {
              navigate("/authentication/sign-in");
            }, 0); // hoặc 0 nếu muốn đi ngay khi Swal đóng
          });
        } else {
          Swal.fire({
            title: data.message,
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } else {
        setResponseData({
          message: "Có lỗi xảy ra trong hệ thống",
          status: 201,
        });
      }
    });
  };

  const handleCloseNotifyLogin = () => setIsLoginFail(false);
  const renderRegisterForm = () => (
    <SuiBox className="w-100">
      <SuiBox mb={2} mt={4} textAlign="center">
        <SuiTypography
          variant="h3"
          fontWeight="bold"
          sx={{
            color: "var(--gray-100)",
            textTransform: "uppercase",
          }}
        >
          Đăng ký
        </SuiTypography>
      </SuiBox>
      <SuiBox component="form" role="form">
        <SuiBox mb={1.75}>
          <SuiTypography
            sx={{
              fontSize: "16px",
              color: "var(--gray-100)",
              fontWeight: "600",
              textTransform: "none",
            }}
          >
            Họ và tên *
          </SuiTypography>
          <TextField
            name="fullname"
            onChange={handleChange}
            sx={{
              width: "100%",
              "& .MuiFilledInput-root": {
                backgroundColor: "var(--blue-gray-line) !important",
              },
              "& .MuiFilledInput-input": {
                height: "22.02px",
                width: "100% !important",
                "::placeholder": {
                  fontStyle: "italic",
                },
              },
              "& .MuiFilledInput-root:before,& .MuiFilledInput-root:after": {
                border: "none",
                content: "none",
              },
              "& label.Mui-focused": {
                color: "var(--blue-blue-100)",
              },
              "& .MuiInputLabel-root": {
                color: "#aeaeae",
              },
              // "& .Mui-focused": {
              //   borderColor: "var(--blue-blue-100) !important",
              // },
            }}
            variant="filled"
            placeholder="Nhập tên của bạn"
            error={responseData.message === "Họ và tên không được để trống"}
            helperText={
              responseData.message === "Họ và tên không được để trống" ? responseData.message : ""
            }
          />
        </SuiBox>
        <SuiBox mb={1.75}>
          <SuiTypography
            sx={{
              fontSize: "16px",
              color: "var(--gray-100)",
              fontWeight: "600",
              textTransform: "none",
            }}
          >
            Email*
          </SuiTypography>
          <TextField
            name="email"
            onChange={handleChange}
            sx={{
              width: "100%",
              "& .MuiFilledInput-root": {
                backgroundColor: "var(--blue-gray-line) !important",
              },
              "& .MuiFilledInput-input": {
                height: "22.02px",
                width: "100% !important",
                "::placeholder": {
                  fontStyle: "italic",
                },
              },
              "& .MuiFilledInput-root:before,& .MuiFilledInput-root:after": {
                border: "none",
                content: "none",
              },
              "& label.Mui-focused": {
                color: "var(--blue-blue-100)",
              },
              "& .MuiInputLabel-root": {
                color: "#aeaeae",
              },
              // "& .Mui-focused": {
              //   borderColor: "var(--blue-blue-100) !important",
              // },
            }}
            variant="filled"
            placeholder="Nhập email của bạn"
            error={
              responseData.message === "Email không hợp lệ" ||
              responseData.message === "Email không được quá 50 ký tự"
            }
            helperText={
              responseData.message === "Email không hợp lệ" ||
              responseData.message === "Email không được quá 50 ký tự"
                ? responseData.message
                : ""
            }
          />
        </SuiBox>
        <SuiBox mb={1.75}>
          <SuiTypography
            sx={{
              fontSize: "16px",
              color: "var(--gray-100)",
              fontWeight: "600",
              textTransform: "none",
            }}
          >
            Số điện thoại
          </SuiTypography>
          <TextField
            name="phoneNumber"
            onChange={handleChange}
            sx={{
              width: "100%",
              "& .MuiFilledInput-root": {
                backgroundColor: "var(--blue-gray-line) !important",
              },
              "& .MuiFilledInput-input": {
                height: "22.02px",
                width: "100% !important",
                "::placeholder": {
                  fontStyle: "italic",
                },
              },
              "& .MuiFilledInput-root:before,& .MuiFilledInput-root:after": {
                border: "none",
                content: "none",
              },
              "& label.Mui-focused": {
                color: "var(--blue-blue-100)",
              },
              "& .MuiInputLabel-root": {
                color: "#aeaeae",
              },
              // "& .Mui-focused": {
              //   borderColor: "var(--blue-blue-100) !important",
              // },
            }}
            variant="filled"
            placeholder="Nhập số điện thoại của bạn"
            error={responseData.message === "Số điện thoại không hợp lệ"}
            helperText={
              responseData.message === "Số điện thoại không hợp lệ" ? responseData.message : ""
            }
          />
        </SuiBox>
        <SuiBox mb={2}>
          <SuiTypography
            sx={{
              fontSize: "16px",
              color: "var(--gray-100)",
              fontWeight: "600",
              textTransform: "none",
            }}
          >
            Mật khẩu
          </SuiTypography>
          <InputPassword
            placeholder="Tạo mật khẩu"
            value={password}
            onChange={setPassword}
            error={
              responseData.message === "Mật khẩu không được để trống" ||
              responseData.message === "Mật khẩu phải có ít nhất 6 ký tự" ||
              responseData.message ===
                "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt" ||
              responseData.message === "Mật khẩu không được quá 50 ký tự"
            }
            helperText={
              responseData.message === "Mật khẩu không được để trống"
                ? "Mật khẩu không được để trống"
                : responseData.message === "Mật khẩu phải có ít nhất 6 ký tự"
                ? "Mật khẩu phải có ít nhất 6 ký tự"
                : responseData.message ===
                  "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt"
                ? "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt"
                : responseData.message === "Mật khẩu không được quá 50 ký tự"
                ? responseData.message
                : ""
            }
          />
        </SuiBox>
        <SuiBox mb={2}>
          <SuiTypography
            sx={{
              fontSize: "16px",
              color: "var(--gray-100)",
              fontWeight: "600",
              textTransform: "none",
            }}
          >
            Xác nhận mật khẩu
          </SuiTypography>
          <InputPassword
            placeholder="Xác nhận lại mật khẩu"
            value={rePassword}
            onChange={setRePassword}
            error={
              responseData.message === "Xác nhận mật khẩu không được để trống" ||
              responseData.message === "Mật khẩu xác nhận không khớp"
            }
            helperText={
              responseData.message === "Xác nhận mật khẩu không được để trống"
                ? "Xác nhận mật khẩu không được để trống"
                : responseData.message === "Mật khẩu xác nhận không khớp"
                ? "Mật khẩu xác nhận không khớp"
                : ""
            }
          />
        </SuiBox>
        {/* Render CAPTCHA after 3 failed attempts */}
        {failedAttempts >= 5 && (
          <div>
            {captchaUrl ? <img src={captchaUrl} alt="Captcha" /> : <p>Đang tải CAPTCHA...</p>}

            <Button
              onClick={handleRefreshCaptcha}
              variant="outlined"
              size="small"
              sx={{ mt: 1, mb: 2 }}
            >
              Tạo mã CAPTCHA mới
            </Button>

            <TextField
              placeholder="Nhập mã CAPTCHA"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              fullWidth
              sx={{
                "& .MuiFilledInput-root": {
                  backgroundColor: "var(--blue-gray-line) !important",
                },
              }}
              error={captchaError}
              helperText={captchaError ? "Vui lòng nhập mã CAPTCHA" : ""}
            />
          </div>
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={agreeTerms}
              onChange={(e) => setAgreeTerms(e.target.checked)}
              color="primary"
            />
          }
          label={
            <Box display="flex" alignItems="center" flexWrap="wrap">
              <Typography variant="body2" fontSize="14px" mr={0.5}>
                Tôi đã đọc và đồng ý với
              </Typography>
              <a
                href="https://zumi.com.vn/chinh-sach-quyen-rieng-tu-app-thiet-ke-dong-phuc-34"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1976d2", textDecoration: "underline", fontSize: "14px" }}
              >
                điều khoản sử dụng
              </a>
            </Box>
          }
          sx={{
            alignItems: "flex-start",
            marginLeft: 0,
            ".MuiFormControlLabel-label": {
              marginLeft: 0,
            },
          }}
        />

        <SuiBox mb={2} textAlign="center">
          <SuiButton
            size="small"
            color="var(--blue-blue-100)"
            circular
            disabled={!agreeTerms}
            sx={{
              width: "100% !important",
              background: !agreeTerms ? "#ccc" : "var(--blue-blue-100)",
              borderRadius: "15px",
              padding: "8px 24px",
              cursor: !agreeTerms ? "not-allowed" : "pointer",
            }}
            onClick={openViewOTP}
          >
            <Typography whiteSpace="nowrap" variant="body2" color="white" fontSize="18px">
              Đăng ký
            </Typography>
          </SuiButton>
          <SuiBox textAlign="center" mt={2}>
            <p style={{ fontSize: "14px" }}>
              Bạn đã có tài khoản?{" "}
              <span
                role="button"
                tabIndex={0}
                onClick={() => navigate("/authentication/sign-in")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    navigate("/authentication/sign-in");
                  }
                }}
                style={{ color: "#1976d2", textDecoration: "underline", cursor: "pointer" }}
              >
                Đăng nhập
              </span>
            </p>
          </SuiBox>
        </SuiBox>
      </SuiBox>
      {isLoginFail && (
        <Snackbar open={isLoginFail} autoHideDuration={3000} onClose={handleCloseNotifyLogin}>
          <Alert severity="error" sx={{ width: "100%" }} onClose={handleCloseNotifyLogin}>
            Thông tin đăng nhập không chính xác.
          </Alert>
        </Snackbar>
      )}

      {/* Display error message if CAPTCHA fails */}
      {captchaError && (
        <Snackbar
          open={Boolean(captchaError)}
          autoHideDuration={3000}
          onClose={() => setCaptchaError(null)}
        >
          <Alert severity="error" sx={{ width: "100%" }} onClose={() => setCaptchaError(null)}>
            {captchaError}
          </Alert>
        </Snackbar>
      )}
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </SuiBox>
  );

  // Main render
  return (
    <>
      <Navbars />
      <PageLayout
        sx={{
          // height: "auto",
          backgroundColor: "#386b59 !important",
          // padding: "24px",
        }}
      >
        <SuiBox sx={{ display: "flex", justifyContent: "flex-start", backgroundColor: "#FBFBFE" }}>
          <Box
            component="img"
            sx={{ width: "160px", height: "auto" }}
            alt="SampleLogo"
            src={SampleLogo}
          />
        </SuiBox>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // height: "calc(100vh - 80px)",
          }}
        >
          <Box
            sx={{ width: "550px", marginTop: "100px", boxShadow: "none" }}
            className="form-container"
          >
            {!isShowOTP ? (
              renderRegisterForm()
            ) : (
              <ValidateOTP username={userData.email} handleSignUp={handleSignUp} />
            )}
          </Box>
        </Box>
      </PageLayout>
    </>
  );
}

export default SignUp;
